"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var useOffsetScroll = function useOffsetScroll(offsetY) {
  var getWindowTop = function getWindowTop() {
    return window.pageYOffset || document.documentElement.scrollTop;
  };

  var getOffsetYBasedOnScrollPosition = _react["default"].useCallback(function () {
    if (getWindowTop() <= offsetY) {
      return offsetY - getWindowTop();
    }

    return 0;
  }, [offsetY]);

  var _React$useState = _react["default"].useState(getOffsetYBasedOnScrollPosition()),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      offsetScroll = _React$useState2[0],
      setOffsetScroll = _React$useState2[1];

  _react["default"].useLayoutEffect(function () {
    setOffsetScroll(getOffsetYBasedOnScrollPosition());

    var handleScroll = function handleScroll() {
      return setOffsetScroll(getOffsetYBasedOnScrollPosition());
    };

    window.addEventListener("scroll", handleScroll);
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [getOffsetYBasedOnScrollPosition]);

  return offsetScroll;
};

var _default = useOffsetScroll;
exports["default"] = _default;
//# sourceMappingURL=useOffsetScroll.js.map